import { AxiosPromise } from 'axios';
import { DeviceType } from 'api/admin/washboard/washboard';
import httpClient from 'api/httpClient';

export type StoreDefaultReleaseInput = {
  deviceType: DeviceType;
  releaseId: number;
};

export type SetStoreDefaultReleasesPayload = {
  storeId: number;
  defaultReleases: StoreDefaultReleaseInput[];
};

export type SetStoreDefaultReleasesResponse = {
  success: boolean;
};

export const setStoreDefaultReleases = ({
  storeId,
  defaultReleases,
}: SetStoreDefaultReleasesPayload): AxiosPromise<SetStoreDefaultReleasesResponse> => {
  return httpClient({
    method: 'PUT',
    url: `super-admin/stores/${storeId}/default-releases`,
    data: { defaultReleases },
  });
};
